import { firebase, auth, googleProvider, githubProvider } from "../lib/firebase";

const providers = {
  googleProvider,
  githubProvider
}

export function signUp(email, password) {
  return firebase.createUserWithEmailAndPassword(auth, email, password);
}

export function logIn(email, password) {
  return firebase.signInWithEmailAndPassword(auth, email, password);
}

export async function signInWithGoogle() {
  const googleUser = await firebase.signInWithPopup(auth, googleProvider);
  return googleUser;
}

export async function signInWithProvider(providerName) {
  let provider = providers[providerName];
  let result;
  try {
    result = await firebase.signInWithPopup(auth, provider);
  }
  catch (error) {
    if (error.code === 'auth/account-exists-with-different-credential') {
      throw new Error('You have signed up with a different provider for that email.');
    }
    else {
      throw error;
    }
  }
  return result;
}

export function logOut() {
  return firebase.signOut(auth);
}

export function reload() {
  auth.currentUser.reload();
}

export function sendVerificationEmail() {
  return firebase.sendEmailVerification(auth.currentUser);
}

export function sendResetEmail(email) {
  return firebase.sendPasswordResetEmail(auth, email);
}

export function useVerifyEmail() {
  return sendVerificationEmail();
}


export function deleteUser() {
  return auth.currentUser.delete();
}

export function getCurrentUser() {
  return auth.currentUser;
}

